import { startRegistration, startAuthentication } from "@simplewebauthn/browser";
import { api } from "@/lib/api";

/**
 * WebAuthn / Passkey utility: registrazione (utente loggato), login (pubblico),
 * check disponibilità biometria device.
 */

export async function hasPlatformAuthenticator() {
  if (!window.PublicKeyCredential?.isUserVerifyingPlatformAuthenticatorAvailable) return false;
  try {
    return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
  } catch {
    return false;
  }
}

export async function hasConditionalMediation() {
  if (!window.PublicKeyCredential?.isConditionalMediationAvailable) return false;
  try {
    return await window.PublicKeyCredential.isConditionalMediationAvailable();
  } catch {
    return false;
  }
}

export async function registerPasskey(name) {
  const opts = await api.post("/auth/webauthn/register/challenge", { name });
  const attResp = await startRegistration({ optionsJSON: opts.data });
  const verify = await api.post("/auth/webauthn/register/verify", { name, credential: attResp });
  return verify.data;
}

export async function loginWithPasskey(email, { useBrowserAutofill = false } = {}) {
  const opts = await api.post("/auth/webauthn/auth/challenge", { email: email || null });
  const assertResp = await startAuthentication({
    optionsJSON: opts.data,
    useBrowserAutofill,
  });
  const verify = await api.post("/auth/webauthn/auth/verify", { credential: assertResp });
  return verify.data; // { access_token, user, refresh_token, ... }
}
